module.exports = __webpack_public_path__ + "img/12.c58e12bf.jpg";